export default "__VITE_ASSET__Dy2_9Hki__"